(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('UpgradeConfirmationDialogController', UpgradeConfirmationDialogController);

    function UpgradeConfirmationDialogController($mdDialog, authentication, billing, utils, $translate) {

        const vm = this;
        vm.billingFrequency = '';

        init();

        vm.upgrade = function () {

            return billing.updatePlan(vm.upgradePlan.id).then(function () {

                const planUpgradedText = $translate.instant('Congratulations! Your plan has been successfully upgraded to {{plan}}.', { plan: vm.upgradePlan.name });

                utils.showSuccessToast(planUpgradedText);

                authentication.fetchMe();
                return $mdDialog.hide(true);
            });
        };

        vm.close = function () {

            return $mdDialog.cancel();
        };

        vm.getPlanText = function () {
            return $translate.instant('You are about to upgrade your subscription to the {{plan}} plan', { plan: vm.upgradePlan.name });
        };

        vm.getSubscriptionUpdateText = function () {
            const when = vm.billingFrequency === 'annually' ? ' ' + $translate.instant('at the start of next month') : '';
            return $translate.instant('Your subscription will be updated and any differences will be billed pro rata{{when}}.', { when });
        };

        function init() {

            billing.get().then(function (response) {


                if (response.data) {
                    vm.billingFrequency = response.data.billing_frequency;
                }
            });
        }
    }
})();
